/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import getFileRoot from './getFileRoot';

/*
 * Import all function using webpack contexts
 * https://webpack.js.org/guides/dependency-management/
 */
export default function importAll(r, reducePath, merge) {
  const result = {};
  r.keys().forEach((key) => {
    if (merge) {
      Object.assign(result, r(key));
    } else {
      const keyName = reducePath ? getFileRoot(key) : key;
      const module = r(key);
      if (module.__esModule) {
        result[keyName] = module.default;
      } else {
        result[keyName] = module;
      }
    }
  });
  return result;
}
